"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EST_START_SOURCES = exports.INVITE_SOURCES = exports.DD_REPORT_GENERATORS = exports.DD_REPORT_STATUSES = exports.DD_REQUEST_STATUSES = exports.SCORECARD_BANDS = exports.CTA_VARIANTS = exports.LEAD_CHANNELS = exports.DELIVERY_STATUSES = exports.MESSAGE_STATUSES = exports.EVENT_SOURCES = exports.CONSENT_PURPOSES = exports.GATE_PLACEMENTS = exports.DD_REQUESTED_VIA = exports.DD_SERVED_FROM = exports.LEAD_CTA_CLICKS = exports.LEAD_LINK_KINDS = exports.MESSAGE_KINDS = exports.SCORECARD_ANSWERS = exports.TOOL_KEYS = exports.KEY_COLLECTION_CHOICES = exports.LEAD_STAGES = void 0;
/** Stage codes from TRD S-07. Labels stay in frontend copy. */
exports.LEAD_STAGES = ["getting_keys", "meeting_ids", "comparing_quotes", "about_to_sign", "signed_not_started", "signed_underway"];
/**
 * Gate field "Key collection date". Labels stay in frontend copy.
 * Keys collected, Within 3 months, Within 6 months, More than 6 months.
 */
exports.KEY_COLLECTION_CHOICES = ["keys_collected", "within_3_months", "within_6_months", "more_than_6_months"];
/** Tools that can appear on an event. `invite_page` is an invite source, not a tool. */
exports.TOOL_KEYS = ["payment_schedule_checker", "id_scorecard", "payment_visualiser", "id_due_diligence", "id_matching"];
/** Scorecard answer codes. TRD §11.2: yes = full points, partially = half, no and not_sure = 0. */
exports.SCORECARD_ANSWERS = ["yes", "partially", "no", "not_sure"];
/** `messages.kind`. Delivery events carry this as `props.kind`. */
exports.MESSAGE_KINDS = ["first_touch", "rerun", "resend", "dd_report"];
/** `short_links.kind` and `link_clicked.props.kind`. */
exports.LEAD_LINK_KINDS = ["pdf", "tool", "report", "invite", "wa_chat"];
/** `cta_clicked.props.cta`. Distinct from the CTA card variant (`match` | `invite`). */
exports.LEAD_CTA_CLICKS = ["get_matched", "invite_id"];
/** `dd_requests.served_from`. */
exports.DD_SERVED_FROM = ["cache", "new", "joined"];
/** `dd_requests.requested_via`. */
exports.DD_REQUESTED_VIA = ["staff", "web"];
/** Checker and Scorecard gate after the preview. The Visualiser has no gate. */
exports.GATE_PLACEMENTS = ["after_preview", "none"];
exports.CONSENT_PURPOSES = ["service", "marketing_updates", "id_invite", "id_invite_with_updates"];
/** `events.source`. */
exports.EVENT_SOURCES = ["web", "system", "team", "platform"];
/**
 * `messages.status`. Includes provider delivery (`delivered`, `read`), which R1 cannot observe.
 * A submission's `DeliveryStatus` is a different list.
 */
exports.MESSAGE_STATUSES = ["queued", "sending", "sent", "delivered", "read", "failed", "suppressed", "awaiting_manual"];
/** `tool_submissions.delivery_status`. */
exports.DELIVERY_STATUSES = ["none", "pending_render", "rendered", "queued", "sent", "failed", "suppressed", "awaiting_manual"];
/** Phase 1 sends on WhatsApp only. */
exports.LEAD_CHANNELS = ["whatsapp"];
/** Which card the result shows. Distinct from `LeadCtaClick`. */
exports.CTA_VARIANTS = ["match", "invite"];
exports.SCORECARD_BANDS = ["strong_confidence", "investigate_further", "slow_down"];
/** `dd_requests.status`. */
exports.DD_REQUEST_STATUSES = ["waiting", "sent", "failed", "cancelled", "awaiting_manual"];
/** `dd_reports.status`. */
exports.DD_REPORT_STATUSES = ["requested", "generating", "draft", "ready", "failed", "expired", "superseded", "withdrawn"];
/** `dd_reports.generator`. */
exports.DD_REPORT_GENERATORS = ["manual_upload", "scripted", "ai"];
/** `id_invites.source_tool`. */
exports.INVITE_SOURCES = ["payment_schedule_checker", "id_scorecard", "payment_visualiser", "invite_page"];
/** `contacts.est_start_source`. */
exports.EST_START_SOURCES = ["given", "assumed"];
/**
 * Sheet `team_status` vocabulary is pending business input B8.
 * No enum until that list exists. Readers take it as a string.
 */
